import { IonPage } from '@ionic/react';
import { useGetReportsByDocumentQuery } from '../../api/ReportApi';
import { ReporterList } from '../../components/admin/ReporterList';

export const ReporterListByDocument: React.FC<{
	documentId: string;
	onDismiss: () => {};
}> = ({ onDismiss, documentId }) => {
	const { data: listOfReporters } = useGetReportsByDocumentQuery({ document: documentId });

	return (
		<IonPage>
			<ReporterList onDismiss={onDismiss} listOfReporters={listOfReporters} />
		</IonPage>
	);
};
